import type { SurveyResponseDto } from '@/shared/api/types'
import { pollStatusLabel } from './vocab'

/**
 * The poll picker every per-poll screen carries.
 *
 * <p>One control, one place, so moving between Fieldwork, Quality and Results
 * keeps the same poll selected — the layout carries the query string and this
 * writes into it. A screen that reset to "all polls" on navigation would make the
 * four screens disagree for a reason nothing on the page explains.
 */
export function PollSelect({ polls, value, onChange }: {
  polls: SurveyResponseDto[]
  value: string | null
  onChange: (id: string) => void
}) {
  return (
    // `min-w` only above the small breakpoint: 280px plus the label is wider than a
    // phone, and the control then ran off the right edge of every per-poll screen.
    <label className="flex w-full items-center gap-1.5 text-erp-xs sm:w-auto">
      Poll
      <select
        className="erp-input h-9 w-full min-w-0 sm:w-auto sm:min-w-[280px]"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Choose a poll…</option>
        {polls.map((poll) => (
          <option key={poll.id} value={poll.id}>
            {poll.ref} · {poll.title} ({pollStatusLabel(poll.statusCode)})
          </option>
        ))}
      </select>
    </label>
  )
}
